import { render, staticRenderFns } from "./List.vue?vue&type=template&id=640aea0d&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=640aea0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640aea0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640aea0d')) {
      api.createRecord('640aea0d', component.options)
    } else {
      api.reload('640aea0d', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=640aea0d&scoped=true&", function () {
      api.rerender('640aea0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/List.vue"
export default component.exports